import actions from '../../actionTypes';

export default site => {
  return {
    type: actions.EDIT_SITE,
    site
  };
};



// WEBPACK FOOTER //
// ./src/reducers/sites/actions/editSite.js